/* import __COLOCATED_TEMPLATE__ from './procedure-static-chart.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';

interface ProcedureStaticChartSignature {
  Args: {
    statType: string;
    label: string;
    procedureId: string;
    chartDefinition: any;
    selectedProcedureId?: string;
    selectedStat?: string;
    drillInColumns: string[];
    onOpenSideDrawer: (procedureId: string, stat: string, event: Event) => void;
    onCloseSideDrawer: () => void;
    tooltip: string;
  };
  Element: HTMLDivElement;
}

export default class ProcedureStaticChart extends Component<ProcedureStaticChartSignature> {
  get isSideDrawerOpen(): boolean {
    return !!(
      this.args.selectedProcedureId &&
      this.args.selectedProcedureId === this.args.procedureId &&
      this.args.selectedStat === this.args.statType
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Tasks::ProcedureStaticChart': typeof ProcedureStaticChart;
    'standalone/tasks/procedure-static-chart': typeof ProcedureStaticChart;
  }
}
